export const details = {
	absentId: 12345,
	firstName: "Melder",
	lastName: "Demo",
	middleName: "van",
	schoolName: "School 64",
	schoolId: 64,
	groups: [
		{
			id: 1,
			name: "Leerkhart group 1",
		},
		{
			id: 2,
			name: "Leerkhart group 2",
		},
		{
			id: 3,
			name: "Leerkhart group 3",
		},
	],
	code: "ZVW",
	codeId: 123,
	days: [
		{
			id: 1234,
			day: "11-06-2025",
			shift: "ochtend",
			weekday: "Monday",
		},
		{
			id: 1235,
			day: "15-06-2025",
			shift: "middag",
			weekday: "Friday",
		},
	],
	gym: "-",
	contracts: [
		{
			id: 1,
			name: "Ingeplang",
			abbr: "Ing",
			open: true,
		},
		{
			id: 2,
			name: "Pooler",
			abbr: "Plr",
			open: true,
		},
		{
			id: 3,
			name: "Geen contract",
			abbr: "Gc",
			open: true,
		},
		{
			id: 4,
			name: "Extern",
			abbr: "Ext",
			open: true,
		},
		{
			id: 5,
			name: "Niemand beschikbaar",
			abbr: "Nbs",
			open: false,
		},
		{
			id: 6,
			name: "Parttimer",
			abbr: "Pt",
			open: false,
		},
	],
};

export const data = [
	{
		id: 1,
		name: "Ingeplang",
		abbr: "Ing",
		users: [
			{
				adminId: 2,
				firstName: "Marie",
				lastName: "Curie",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 15,
				kmMax: 50,
				age: 35,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "!",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "!",
						shift: "middag",
					},
				],
			},
			{
				adminId: 3,
				firstName: "Nikola",
				lastName: "Tesla",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "!",
				fb: "+",
				con: "81/0",
				match: "--",
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "-",
						shift: "middag",
					},
				],
			},
			{
				firstName: "Albert",
				adminId: 1,
				lastName: "Einstein",
				middleName: "van",
				vog: "-",
				id: "+",
				pabo: "+",
				d36mnd: "-",
				kr: "+",
				bk: "+",
				gym: "-",
				fv: "-",
				fb: "-",
				con: "12/0",
				match: 99,
				km: 5,
				kmMax: null,
				age: 43,
				score: "-",
				messages: 50,
				messagesEnabled: false,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "19-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "19-05-2025",
						value: "+",
						shift: "middag",
					},
				],
			},
		],
	},
	{
		id: 2,
		name: "Pooler",
		abbr: "Plr",
		users: [
			{
				firstName: "Albert",
				adminId: 4,
				lastName: "Einstein",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "+",
						shift: "middag",
					},
				],
			},
			{
				firstName: "Albert",
				adminId: 5,
				lastName: "Einstein",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "!",
						shift: "middag",
					},
				],
			},
		],
	},
	{
		id: 3,
		name: "Geen contract",
		abbr: "Gc",
		users: [
			{
				firstName: "Albert",
				adminId: 6,
				lastName: "Einstein",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "+",
						shift: "middag",
					},
				],
			},
			{
				firstName: "Albert",
				adminId: 7,
				lastName: "Einstein",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "!",
						shift: "middag",
					},
				],
			},
		],
	},
	{
		id: 4,
		name: "Extern",
		abbr: "Ext",
		users: [
			{
				firstName: "Albert",
				adminId: 8,
				lastName: "Einstein",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "+",
						shift: "middag",
					},
				],
			},
			{
				firstName: "Albert",
				adminId: 9,
				lastName: "Einstein",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "!",
						shift: "middag",
					},
				],
			},
		],
	},
	{
		id: 5,
		name: "Niemand beschikbaar",
		abbr: "Nbs",
		users: [
			{
				firstName: "Albert",
				adminId: 10,
				lastName: "Einstein",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "+",
						shift: "middag",
					},
				],
			},
			{
				firstName: "Albert",
				adminId: 11,
				lastName: "Einstein",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "!",
						shift: "middag",
					},
				],
			},
		],
	},
	{
		id: 6,
		name: "Parttimer",
		abbr: "Pt",
		users: [
			{
				firstName: "Albert",
				adminId: 13,
				lastName: "Einstein",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "+",
						shift: "middag",
					},
				],
			},
			{
				firstName: "Albert",
				adminId: 14,
				lastName: "Einstein",
				middleName: "van",
				vog: "+",
				id: "-",
				pabo: "-",
				d36mnd: "+",
				kr: "-",
				bk: "locked",
				gym: "+",
				fv: "+",
				fb: "!",
				con: "81/0",
				match: 5,
				km: 8,
				kmMax: 5,
				age: 50,
				score: "-",
				messages: 50,
				messagesEnabled: true,
				selected: false,
				selectedToReceiveMessage: false,
				b: 0,
				e: 100,
				availability: [
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "12-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Tuesday",
						date: "13-05-2025",
						value: "-",
						shift: "middag",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Wednesday",
						date: "14-05-2025",
						value: "!",
						shift: "middag",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "ochtend",
					},
					{
						weekday: "Friday",
						date: "16-05-2025",
						value: "+",
						shift: "middag",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "-",
						shift: "ochtend",
					},
					{
						weekday: "Monday",
						date: "19-05-2025",
						value: "!",
						shift: "middag",
					},
				],
			},
		],
	},
];

export const memoData = [
	{
		memo: "Blabladfjdl fjasdkl fsdkl fsd;l fjsdkl fsd;jlf ;sa fasd fksd fjsd; fjsdklf sdlf lsd; fja",
		mobielNumber: "12-34567890",
		city: "Sevenum",
	},
];

export const contactData = [
	{
		phoneEnabled: true,
		smsEnabled: true, 
		isAvailable: true, 
		deniesRequests: false, 
		otherReason: false,
		note: 'test'
	}
]